// import { Link } from "react-router-dom";
import { Badges, P, SVG } from "../../../AbstractElements";
// import { Href } from "../../../utils/Constant";
// import { Rating } from "react-simple-star-rating";
// import { dynamicImage } from "../../../Service";
import { TableColumn } from "react-data-table-component";
import { AllClothAssignTableDataColumnType, AllClothAssignTableOffer } from "../../../Types/Application/Ecommerce/Ecommerce";
import Swal from "sweetalert2";
import api from "../../../utils/api";

export const allLockerAssignTableData = [
    {
      clothCalculationId: 1019,
      totalCloth: 5,
      subTotalAmount: 100,
      gst: 5,
      refundAmount: 100,
      grandTotalAmount: 399,
      isLocked: true,
      ticketRFIdRef: "REF-SWP-2311",
      selectedCardID: "1",
      clothAssignDate:"2025-06-12T17:51:02.9149565"
    },
    {
      clothCalculationId: 1029,
      totalCloth: 5,
      subTotalAmount: 100,
      gst: 5,
      refundAmount: 100,
      grandTotalAmount: 399,
      isLocked: true,
      ticketRFIdRef: "REF-SWP-2312",
      selectedCardID: "1",
      clothAssignDate:"2025-06-12T17:51:02.9149565"
    }
];

// const ProductListTableAction = ({adultPlanId}) => {
//   return (
//     <div className="product-action">
//       <Link to={Href}>
//         <SVG iconId="edit-content" style={{ fill: 'blue' }} />
//       </Link>
//       <button className="btn btn-sm">
//       <SVG iconId="trash1" style={{ fill: 'red' }}/>
//       </button>
//       <p>{adultPlanId}</p>
//     </div>
//   );
// };

const handleDelete = async (id: number) => {
    try {
      await api.put(`/api/ClothCalculation/ReturnRFIDCard?clothCalculationId=${id}`);
      Swal.fire('Return!', '  Cloth has been return submitted.', 'success');
  
      // Optional: refresh the list
    //   setCardAssignTableDatas((prev) => prev.filter((item: { adultPlanId: any; }) => item.adultPlanId !== id));
    } catch (error) {
      Swal.fire('Error!', 'Failed to submit return the record.', 'error');
      console.error("Return error:", error);
    }
  };

interface ProductListTableActionProps {
    clothCalculationId: any;
  onDelete: (id: number) => void;
}

export const AllClothAssignTableAction: React.FC<ProductListTableActionProps> = ({ clothCalculationId, onDelete }) => {

  const handleDeleteClick = () => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this record!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, return it!',
    }).then((result) => {
      if (result.isConfirmed) {
        onDelete(clothCalculationId);
      }
    });
  };

  return (
    <div className="product-action d-flex gap-2">
      <button className="btn btn-xs btn-danger" title="Return Clothes" onClick={handleDeleteClick}>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
          <path d="M19 7v4H6.83l3.59-3.59L9 6l-6 6 6 6 1.41-1.41L6.83 13H21V7z"/>
        </svg>
      </button>
    </div>
  );
};

export const AllLockerAssignTableProductName: React.FC<AllClothAssignTableOffer> = ({ title }) => {
  return (
    <div className="product-names my-2">
      <P>{title}</P>
    </div>
  );
};

export const AllClothAssignTableStatus :React.FC<AllClothAssignTableOffer> = ({ title }) => {
  return (
    <Badges color="" className={`badge-light-${title === "Active" ? "secondary" : "primary" }`}>{title}</Badges>
  );
};

export const allClothAssignTableDataColumn: TableColumn<AllClothAssignTableDataColumnType>[] = [
  {
    name: "Ticket ID",
    cell: (row) => <AllLockerAssignTableProductName title={row.ticketRFIdRef}/>,
    sortable: true,
    grow: 2,
  },
  {
    name: "RFID Card No.",
    selector: (row) => `${row.selectedCardID}`,
    sortable: true,
    grow: 2,
  },
  {
    name: "Total Cloth",
    selector: (row) => `${row.totalCloth}`,
    sortable: true,
  },
  {
    name: "Total Amount",
    selector: (row) => `${row.subTotalAmount}`,
    sortable: true,
  },
  {
    name: "GST",
    selector: (row) => `${row.gst}`,
    sortable: true,
  },
  {
    name: "Refund Amt",
    selector: (row) => `${row.refundAmount}`,
    sortable: true,
  },
  {
    name: "Grand Total Amount",
    selector: (row) => `${row.grandTotalAmount}`,
    sortable: true,
  },
  {
    name: "Status",
    cell: (row) =>  <AllClothAssignTableStatus title={row.isLocked ? "Active" : "Inactive"} />,
  },
  {
    name: "Assign Date",
    cell: (row) => <AllClothAssignTableStatus title={new Date(row.clothAssignDate).toLocaleDateString()} />,
  },
  {
    name: "Action",
    cell: (row) => <AllClothAssignTableAction clothCalculationId={row.clothCalculationId} onDelete={handleDelete} />,
  },
  ];

  export const filtersData = [
    {
      name: "Choose Ticket ID",
      options: ["SWP-4893", "SWP-2311"],
    },
    {
      name: "Status",
      options: ["Active", "Inactive"],
    },
    {
      name: "customerMobileNumber",
      options: ["8347821920"],
    },
  ];